module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/eyecatch-23887cd93b88cefc010f4533474634dd.png";